module.exports = __webpack_public_path__ + "img/Close.c27eb38db.svg";